/**
 * Equipment type constants for rack canvas.
 * Single Responsibility: owns all type-to-display mappings.
 * Open/Closed: extend by merging custom configs — don't edit this file.
 */

/** Brand colors per equipment type (hex). Used for colored left-border and overlay. */
export const TYPE_COLORS: Record<string, string> = {
  server:        '#3b82f6',  // blue-500
  switch:        '#22c55e',  // green-500
  router:        '#06b6d4',  // cyan-500
  patch_panel:   '#a855f7',  // purple-500
  storage:       '#eab308',  // yellow-500
  firewall:      '#ef4444',  // red-500
  pdu:           '#f97316',  // orange-500
  ups:           '#14b8a6',  // teal-500
  organizer:     '#64748b',  // slate-500
  blanking_panel:'#1e293b',  // slate-800
  unknown:       '#64748b',  // slate-500
};

/** Russian display names per equipment type. */
export const TYPE_NAMES_RU: Record<string, string> = {
  server:        'Сервер',
  switch:        'Коммутатор',
  router:        'Маршрутизатор',
  patch_panel:   'Патч-панель',
  storage:       'СХД',
  firewall:      'Файрвол',
  pdu:           'PDU',
  ups:           'ИБП',
  organizer:     'Организатор',
  blanking_panel:'Заглушка',
  unknown:       'Устройство',
};

/** Typical max power per type (Wt) — used for thermal heuristic. */
export const TYPICAL_MAX_POWER: Record<string, number> = {
  server:        500,
  switch:        150,
  storage:       400,
  firewall:      200,
  router:        100,
  pdu:           30,
  ups:           50,
  patch_panel:   5,
  organizer:     0,
  blanking_panel:0,
  unknown:       200,
};

/** Returns device status category for status-indicator dot. */
export function getDeviceStatus(status?: string): 'ok' | 'warning' | 'critical' {
  if (!status) return 'ok';
  const s = status.toLowerCase();
  if (s === 'failed' || s === 'decommissioning' || s === 'offline') return 'critical';
  if (s === 'staged' || s === 'planned' || s === 'inventory') return 'warning';
  return 'ok';
}

/** Returns a 0..100 thermal percentage for a rack equipment item. */
export function getDeviceThermalPct(eq: { id: string; equipment_type: string; power_w?: number; _thermalPct?: number }): number {
  if (eq._thermalPct !== undefined) return eq._thermalPct;
  if (eq.power_w !== undefined && eq.power_w !== null) {
    const max = TYPICAL_MAX_POWER[eq.equipment_type] || 300;
    return Math.min(100, Math.round((eq.power_w / max) * 100));
  }
  // Deterministic pseudo-random fallback from entity ID
  let hash = 0;
  for (let i = 0; i < eq.id.length; i++) {
    hash = eq.id.charCodeAt(i) + ((hash << 5) - hash);
  }
  return 30 + (Math.abs(hash) % 50);
}
